import { ReactNode } from 'react'
import { Heading } from '@homebot/shared-ui-swashbuckle'

import styles from './AdditionalInfo.module.scss'

export interface AdditionalInfoProps {
  visible: boolean
  children: ReactNode
  headingText: string
}

export const AdditionalInfo = ({
  visible,
  children,
  headingText,
}: AdditionalInfoProps) => {
  if (!visible) return null

  return (
    <>
      <div className={styles.arrowUp} />
      <div className={styles.content}>
        <Heading as='h3' size='sm'>
          {headingText}
        </Heading>
        {children}
      </div>
    </>
  )
}
